import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	init();
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
		$w('#albumsGallery').reportPageLoaded('sets');
	}
})

function init() {
	$w('#columnStrip2').hide && $w('#columnStrip2').hide()
	$w('#columnStrip3').hide && $w('#columnStrip3').hide()
	$w('#columnStrip4').show && $w('#columnStrip4').show()
	$w('#box16').hide && $w('#box16').hide()
}

function refreshAlbumData({albumData, sets}) {
	try {
		if (!albumData || !sets) {
			return;
		}
		$w('#albumName').text = albumData.albumName;
		$w('#link2Gog').link = '/';
		$w('#gallery').items = albumData.gogItems;
		$w('#gallery').options = albumData.gogOptions;
		$w('#gallery').onItemClicked((result) => {
			wixLocation.to(result.item.link)
		});
	} catch (e) {
		console.error("Error_On_Page", e);
	}
}

